module.exports = __webpack_public_path__ + "img/hr-rock-big-01.18291d39.png";